module.exports = __webpack_public_path__ + "static/media/eng_d_2480.f116c7e5.mp4";